module.exports = __webpack_public_path__ + "static/media/telephone.ae23f2b1.ogg";